import { render, staticRenderFns } from "./SeleccionarOS.vue?vue&type=template&id=0abb98b5&scoped=true"
import script from "./SeleccionarOS.vue?vue&type=script&lang=js"
export * from "./SeleccionarOS.vue?vue&type=script&lang=js"
import style0 from "./SeleccionarOS.vue?vue&type=style&index=0&id=0abb98b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abb98b5",
  null
  
)

export default component.exports